import "./Sponsor.css";
const Sponsor = () => {
  return (
    <div className="sp-wrapper ">
      <div className="sp-image-container flexCenter">
        <img src="image/br-1.png" alt="" />
        <img src="image/br-2.png" alt="" />
        <img src="image/br-3.png" alt="" />
        <img src="image/br-4.png" alt="" />
        <img src="image/br-5.png" alt="" />
      </div>
    </div>
  );
};

export default Sponsor;
